<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { authComputed } from '@state/helpers'
import Appmenu from './app-menu'

/**
 * Left sidebar component - contains mainly the application menu
 */
export default {
	components: { VuePerfectScrollbar, Appmenu },
	props: {
		isCondensed: {
			type: Boolean,
			default: false,
		},
		theme: {
			type: String,
			required: true,
		},
		type: {
			type: String,
			required: true,
		},
		width: { type: String, required: true },
		user: {
			type: Object,
			required: false,
			default: () => ({}),
		},
	},
	data() {
		return {
      		admin: {},
			settings: {
				minScrollbarLength: 60,
			},
			screen:'',
			show:true,
		}
	},
	computed: {
		...authComputed,
	},
	watch: {
		theme: function(newVal, oldVal) {
			if (newVal !== oldVal) {
				switch (newVal) {
					case 'dark':
						document.body.classList.add('left-side-menu-dark')
						document.body.classList.remove('left-side-menu-condensed')
						document.body.classList.remove('boxed-layout')
						break
					default:
						document.body.classList.remove('left-side-menu-dark')
						break
				}
			}
		},
		type: function(newVal, oldVal) {
			if (newVal !== oldVal) {
				switch (newVal) {
					case 'condensed':
						document.body.classList.add('left-side-menu-condensed')
						document.body.classList.remove('left-side-menu-dark')
						document.body.classList.remove('boxed-layout')
						break
					default:
						document.body.classList.remove('left-side-menu-condensed')
						break
				}
			}
		},
		width: function(newVal, oldVal) {
			if (newVal !== oldVal) {
				switch (newVal) {
					case 'boxed':
						document.body.classList.add('left-side-menu-condensed')
						document.body.classList.remove('left-side-menu-dark')
						document.body.classList.add('boxed-layout')
						break
					default:
						document.body.classList.remove('left-side-menu-condensed')
						document.body.classList.remove('boxed-layout')
						break
				}
			}
		},
	},
  created() {
    this.admin = this.$store.state.auth.currentUser.data.user
  },
  mounted(){
	var _this = this;
	this.screen =  window.innerWidth;
	_this.$nextTick(() => {
	window.addEventListener('resize', this.onResize);
    })
  },
  methods:{
	 onResize() {
          var _this = this;
		  this.screen =   window.innerWidth;
		  console.log(this.onResize);
    },
	myFunction(){
		this.show = !this.show;
// 		var x = document.getElementById("myTopnav");
//   if (x.className === "topnav") {
//     x.className += " responsive";
//   } else {
//     x.className = "topnav";
//   }
	},
  },
  beforeDestroy() {
            window.removeEventListener('resize', this.onResize); 
        },
}
</script>

<template>
	<!-- ========== Left Sidebar Start ========== -->
	<div class="left-side-menu text-white" v-if="screen > 767" >
		<div class="mt-5 mb-4">
			<b-img 
				center
				:src="require('@assets/images/logoCJ-no-text.png')"
				width="80"
				@click="$router.push('/')"
				class="cursor-pointer" 
			/>
			<div class="text-center">{{ admin.role }}</div>
		</div>
		<div id="sidebar-menu" class="pb-2">
			<ul id="account-menu" class="metismenu pb-0 mb-0">
				<li
				class="side-nav-title side-nav-item w-100"
				>   
					<a
					href="/myaccount"
					class="side-nav-link side-nav-link-ref"
					>
						<img
							src="@assets/images/users/avatar-7.jpg"
							class="avatar-sm rounded-circle mr-2"
							alt="Shreyu"
						/>
					<span>{{ admin.firstName + ' ' + admin.lastName }}</span>
					</a>
				</li>					
			</ul> 				
		</div>		
		<!-- <div class="media user-profile">
			<img
				src="@assets/images/users/avatar-7.jpg"
				class="avatar-sm rounded-circle mr-2"
				alt="Shreyu"
			/>
			<img
				src="@assets/images/users/avatar-7.jpg"
				class="avatar-xs rounded-circle mr-2"
				alt="Shreyu"
			/>

			<div class="media-body align-self-center">
				<h6 class="pro-user-name mt-0 mb-0">{{ admin.firstName + ' ' + admin.lastName }}</h6>
			</div>
			<b-dropdown right variant="black" class="align-self-center" toggle-class="p-0">
				<template v-slot:button-content>
					<feather type="chevron-down" class="align-middle"></feather>
				</template>

				<b-dropdown-item href="/myaccount" class="notify-item">
					<feather
						type="user"
						class="icon-dual icon-xs mr-2 align-middle"
					></feather>
					<span>My Account</span>
				</b-dropdown-item>

				<b-dropdown-divider></b-dropdown-divider>

				<b-dropdown-item href="/logout" class="notify-item">
					<feather
						type="log-out"
						class="icon-dual icon-xs mr-2 align-middle"
					></feather>
					<span>Logout</span>
				</b-dropdown-item>
			</b-dropdown>
		</div>		 -->
		<div class="sidebar-content">
			<VuePerfectScrollbar
				v-if="!isCondensed"
				v-once
				:settings="settings"
				class="h-100"
			>			
				<div id="sidebar-menu">
					<Appmenu />
				</div>
			</VuePerfectScrollbar>
			<div v-else id="sidebar-menu">
				<Appmenu />
			</div>
			<div id="sidebar-menu">
				<ul id="account-menu" class="metismenu">
					<li
					class="side-nav-title side-nav-item w-100 position-absolute"
					>   
						<a
						href="/logout"
						class="side-nav-link side-nav-link-ref"
						>
						<feather type="log-out"></feather>
						<span>Log Out</span>
						</a>
					</li>					
				</ul> 				
			</div>						
		</div>
		<!-- Sidebar -left -->
	</div>
	<div v-else  class="text-white topnav responsive" id="myTopnav">
		<div id="sidebar-menu" class="pb-2">
			<ul id="account-menu" class="metismenu pb-0 mb-0">
				<li
				class="side-nav-title side-nav-item w-100"
				>   
					<a
					href="/myaccount"
					class="side-nav-link side-nav-link-ref"
					>
						<img
							src="@assets/images/users/avatar-7.jpg"
							class="avatar-sm rounded-circle mr-2"
							alt="Shreyu"
						/>
					<span>{{ admin.firstName + ' ' + admin.lastName }}</span>
					</a>
				</li>					
			</ul> 				
		</div>
		<div class="sidebar-content" v-if="!show">
			<VuePerfectScrollbar
				v-if="!isCondensed"
				v-once
				:settings="settings"
				class="h-100"
			>			
				<div id="sidebar-menu">
					<Appmenu />
				</div>
			</VuePerfectScrollbar>
			<div v-else id="sidebar-menu">
				<Appmenu />
			</div>
			<div id="sidebar-menu">
				<ul id="account-menu" class="metismenu">
					<li
					class="side-nav-title side-nav-item w-100 position-absolute"
					>   
						<a
						href="/logout"
						class="side-nav-link side-nav-link-ref"
						>
						<feather type="log-out"></feather>
						<span>Log Out</span>
						</a>
					</li>					
				</ul> 				
			</div>						
		</div>		
   <a  class="icon" v-on:click="myFunction()">
  	<feather type="menu" class="menu-icon align-middle"></feather>
  </a>
	</div>
	<!-- Left Sidebar End -->
</template>

<style lang="scss">
.slimscroll-menu {
	height: 100%;
}
.ps > .ps__scrollbar-y-rail {
	width: 8px !important;
	background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
	width: 6px !important;
}
.user-profile {
    padding: 15px 26px 15px 30px;
	.pro-user-name {
		color: #ffffff;
	}
	.dropdown-toggle svg {
		color: #ffffff;
	}
}

@media (max-width: 767.98px) {
	.logo-box, .pro-user-name {
		display: unset;
	}
}

@media (min-width: 1024px) {
	.side-user {
		display: none !important;
	}
}
.topnav {
  overflow: hidden;
  background-color: #333;
}

.topnav a {
  float: left;
  display: block;
  color: #f2f2f2;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  font-size: 17px;
}

.topnav a:hover {
  background-color: #ddd;
  color: black;
}

.topnav a.active {
  background-color: #04AA6D;
  color: white;
}



@media screen and (max-width: 767px) {
  .topnav a:not(:first-child) {display: none;}
  .topnav a.icon {
    float: right;
    display: block;
  }
}

@media screen and (max-width: 767px) {
  .topnav.responsive {position: relative;}
  .topnav.responsive .icon {
    position: absolute;
    right: 0;
    top: 0;
  }
  .topnav.responsive a {
    float: none;
    display: block;
    text-align: left;
  }
}
</style>
